import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PageTableHeader from "../../../../components/pageTableHeader/pageTableHeader";
import ProfileCard from "./components/profileCard";
import CustomTab, {
  TabContainer,
} from "../../../../components/tabs/customTabs";
import BasicCard from "./components/basicCard";
import ActivityLogs from "./components/activityLogs";
import Interviews from "./components/interviews";
import { getJobApplicationDetail } from "../../../../../services/workspace/recruitment.service";
import { useCommonFetch } from "../../../../../hooks";

const items = [
  { label: "Candidates", path: "/recruitment/candidates" },
  { label: "Candidate Detail", path: "" },
];

const CandidateProfile = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const {
    loading,
    data: data,
    fetchData,
    refreshData,
    // handleUpdate,
  } = useCommonFetch(getJobApplicationDetail, {
    id,
    dataPath: "jobApplication",
    errorMessage: "Failed to fetch Candidates detail!",
    customParams: {
      with: "jobOpening",
    },
  });



  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = Number(params.get("tab"));
    if (!isNaN(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  // ✅ when user clicks tab
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  const tabs = useMemo(() => [
    {
      id: 0,
      label: "Overview",
      content: (
        <BasicCard
        fetchData={fetchData}
        data={data}
        loading={loading}
        // heandleFetchData={heandleFetchData}
        />
      ),
    },
    {
      id: 1,
      label: "Interviews",
      content: (
        <Interviews
        id={data.id}
        rounds={data?.jobOpening?.rounds || []}
        // fetchData={fetchData}
        // leadData={leadData}
        // loading={loading}
        // heandleFetchData={heandleFetchData}
        />
      ),
    },
    // {
    //   id: 2,
    //   label: "Activity Logs",
    //   content: (
    //     <ActivityLogs
    //     // fetchData={fetchData}
    //     // leadData={leadData}
    //     // loading={loading}
    //     // heandleFetchData={heandleFetchData}
    //     />
    //   ),
    // },
  ]);

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader breadcrumbs={items} />
      <ProfileCard data={data} fetchData={fetchData} id={id} loading={loading}/>
      <div className="flex flex-col gap-2 ">
        <div className="flex flex-row items-center justify-between">
          <CustomTab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </div>
        <div className="">
          <TabContainer tabs={tabs} activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
};

export default CandidateProfile;
